import React, { PropsWithChildren } from "react";
import { useTranslations } from "@jugl-web/utils";
import { Button } from "@jugl-web/ui-kit";
import { useKnowledgeTraining } from "@web-src/modules/cx/providers/KnowledgeTrainingProvider";
import { ReactComponent as ArrowIcon } from "./assets/arrow.svg";
import { AgentKnowledgeContentHeader } from "../AgentKnowledgeContentHeader";
import { BlockingOverlayLoader } from "../BlockingOverlayLoader/BlockingOverlayLoader";

export const AgentKnowledgeContentContainer: React.FC<
  PropsWithChildren<{
    title: string;
    description: string;
    icon: React.ReactNode;
    onAddItem?: () => void;
  }>
> = ({ description, icon, title, children, onAddItem }) => {
  const { t } = useTranslations();
  const { trainingStatus } = useKnowledgeTraining();

  return (
    <div className="flex h-full flex-col bg-white">
      <AgentKnowledgeContentHeader
        icon={icon}
        title={title}
        description={description}
        endContent={
          onAddItem ? (
            <Button
              variant="secondary"
              onClick={onAddItem}
              iconEnd={<ArrowIcon />}
              size="sm"
              isDisabled={trainingStatus === "in_process"}
            >
              {t({
                id: "cx-ai-agents-page.add-new",
                defaultMessage: "Add New",
              })}
            </Button>
          ) : undefined
        }
      />
      <div className="relative h-full min-h-0">
        <BlockingOverlayLoader />
        <div className="jugl__custom-scrollbar flex h-full w-full flex-col gap-6 overflow-y-auto p-10 pt-8">
          {children}
        </div>
      </div>
    </div>
  );
};
